import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Sparkles, TrendingDown, FileText, Target, History } from "lucide-react";
import { call, streamPost, dateTime } from "@/lib/api";

const TYPES = [
  { id: "cost-analysis", label: "Analisis Cost Overrun", icon: TrendingDown },
  { id: "daily-summary", label: "Ringkas Daily Report", icon: FileText },
  { id: "margin-forecast", label: "Prediksi Margin", icon: Target },
];

export function AIInsightPanel({ projectId = "", compactMode = false }) {
  const [running, setRunning] = useState("");
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [err, setErr] = useState("");
  const [history, setHistory] = useState([]);
  const loadHistory = () => call.get(`/ai/insights${projectId ? `?project_id=${projectId}` : ""}`).then(setHistory).catch(() => {});
  useEffect(() => { loadHistory(); }, [projectId]); // eslint-disable-line react-hooks/exhaustive-deps

  const run = async (t) => {
    setRunning(t.id); setErr(""); setText(""); setTitle(t.label);
    try { await streamPost("/ai/insight", { type: t.id, project_id: projectId }, setText); loadHistory(); }
    catch (e) { setErr(e.message); }
    finally { setRunning(""); }
  };

  return (
    <div className="panel ai-panel" data-testid="ai-insight-panel">
      <div className="panel-head">
        <div><span className="eyebrow">AI ASSISTANT · GPT-5.5</span><h3><Sparkles size={16} style={{verticalAlign:"-3px",marginRight:6,color:"#f59e0b"}} />Insight {projectId ? "proyek" : "portofolio"}</h3></div>
      </div>
      <div className="ai-actions">
        {TYPES.map(t => (
          <button key={t.id} className={`ai-btn ${running === t.id ? "busy" : ""}`} disabled={!!running} data-testid={`ai-${t.id}-button`} onClick={() => run(t)}>
            <t.icon size={14} /> {running === t.id ? "Menganalisis…" : t.label}
          </button>
        ))}
      </div>
      {err && <div className="error" data-testid="ai-error">{err}</div>}
      {(text || running) && (
        <div className="ai-output" data-testid="ai-output">
          <small className="eyebrow">{title}{running && <span className="ai-cursor" />}</small>
          <ReactMarkdown>{text || "_Mengumpulkan data ERP dan menyusun analisis…_"}</ReactMarkdown>
        </div>
      )}
      {!compactMode && history.length > 0 && !text && (
        <div className="ai-history">
          <small className="eyebrow"><History size={12} /> RIWAYAT ANALISIS</small>
          {history.slice(0, 4).map(h => (
            <button key={h.id} className="ai-history-item" data-testid={`ai-history-${h.id}`} onClick={() => { setTitle(h.title); setText(h.content); }}>
              <b>{h.title}</b><span>{h.project_id || "Portofolio"} · {h.requested_by} · {dateTime(h.created_at)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
